import { isiOS, isMiniProgram } from "./util";

//跳转到商城
export const reviewMall = () => {
    if (isMiniProgram()) {
        wx.miniProgram.switchTab({
            url: "/pages/mall/mall",
        });
    } else {
        if (isiOS()) {
            window.webkit.messageHandlers.reviewMall.postMessage({});
        } else {
            window.android.reviewMall();
        }
    }
    // window.android.
}
//跳转到卡券详情
export const checkCardDetail = (autoStatus, equityId, orderSn, id) => {
    if (isMiniProgram()) {
        wx.miniProgram.navigateTo({
            url: `/couponPage/pages/historyCode/index?couponId=${id}&equityId=${equityId}&autoStatus=${autoStatus}&orderSn=${orderSn}`,
        });
    } else {
        if (isiOS()) {
            window.webkit.messageHandlers.checkCardDetail.postMessage({ autoStatus, equityId, orderSn });
        } else {
            window.android.checkCardDetail(autoStatus, equityId, orderSn);
        }
    }
}

// 跳转到app周期卡
export const gotoCouponsPackage = (recordId, carNumber) => {
    if (isiOS()) {
        window.webkit.messageHandlers.gotoCouponsPackage.postMessage({recordId, carNumber});
    } else {
        window.android.gotoCouponsPackage(recordId, carNumber);
    }
}

//跳转到商详页
export const toGoodsDetail = (type, goodsId, goodsSn, productId = '') => { //type 0-自营 1-京东 2-权益
    var productid = productId?productId:''
    var url = type ? '/commonPage/pages/goods/goods' : '/commonPage/pages/ownGoods/index'
    if (type == 2) {
        url = `/pages/index/GiftBag/index?goodsId=${goodsId}&goodsSn=${goodsSn}`
    } else {
        url = url + `?id=${goodsId}`
    }
    if(productId){
        url = url + `&productId=${productid}`
    }

    checkAppGoodsDetail(type, goodsId, url, productId);
}

//跳转到商详页
export const checkAppGoodsDetail = (type, id, url, productId) => {
    if (isMiniProgram()) {
        wx.miniProgram.navigateTo({
            // url: "/commonPage/pages/goods/goods?id=" + goodsId,
            url
        });
    } else {
        if (isiOS()) {
            window.webkit.messageHandlers.checkAppGoodsDetail.postMessage({ type: type.toString(), id: id.toString(), skuID: productId });
        } else {
            window.android.checkAppGoodsDetail(parseInt(type), id.toString(), productId);
        }
    }
}

//跳转到权益升级活动页
export const checkAppRights = () => {
    if (isMiniProgram()) {

    } else {
        if (isiOS()) {
            window.webkit.messageHandlers.checkAppRights.postMessage({});
        } else {
            window.android.checkAppRights();
        }
    }
}

//拉起原生支付方式选择
export const choosePayWay = (orderId, amount) => {
    if (isiOS()) {
        window.webkit.messageHandlers.checkAppRights.choosePayWay({ orderId, amount });
    } else {
        window.android.choosePayWay(orderId, amount);
    }
}

//拉起原生支付方式选择
export const goSettle = (cartId, deptId, carNumber) => {
    if (isiOS()) {
        window.webkit.messageHandlers.goSettle.postMessage({ cartId, deptId, carNumber });
    } else {
        window.android.goSettle(cartId, deptId, carNumber);
    }
}
//拉起登录
export const signIn = () => {
    if (!isMiniProgram()) {
        if (isiOS()) {
            window.webkit.messageHandlers.signIn.postMessage({});
        } else {
            window.android.signIn();
        }
    }
}

//拉起登录
export const reviewCouponPage = () => {
    if (!isMiniProgram()) {
        if (isiOS()) {
            window.webkit.messageHandlers.checkCouponList.postMessage({});
        } else {
            window.android.checkCouponCenterPreferential();
        }
    } else {
        wx.miniProgram.navigateTo({
            url: '/couponPage/pages/couponCenter/couponCenter?status=0'
        });
    }
}
export const toKeepCarPage = (url, goodsSn) => {
    if (!isMiniProgram()) {
        if (isiOS()) {
            window.webkit.messageHandlers.carMaintenance.postMessage({goodsSn});
        } else {
            window.android.jumpCarMaintenance(goodsSn);
        }
    } else {
        url = goodsSn ? `${url}?goodsSn=${goodsSn}&fromType=h5` : url;
        console.log(11111111111, url)
        wx.miniProgram.navigateTo({
            url
        });
    }
}

//拉起原生填写订单页
export const carWashGoBuy = (serveCityId, goodsId, productId, serviceCity, deptId, deptName) => {
    if (isiOS()) {
        window.webkit.messageHandlers.carWashGoBuy.postMessage({serveCityId, goodsId, productId, serviceCity, deptId, deptName});
    } else {
        window.android.carWashGoBuy(serveCityId, goodsId, productId, serviceCity, deptId, deptName);
    }
}
//拉起原生车辆信息页面
export const carWashInfo = () => {
    if (isiOS()) {
        window.webkit.messageHandlers.carWashInfo.postMessage({});
    } else {
        window.android.carWashInfo();
    }
}
//拉起原生我的页面
export const carWashMine = () => {
    if (isiOS()) {
        window.webkit.messageHandlers.carWashMine.postMessage({});
    } else {
        window.android.carWashMine();
    }
}

// 拉起原生搜索页面
export const carWashSearch = () => {
    if (isiOS()) {
        window.webkit.messageHandlers.carWashSearch.postMessage({});
    } else {
        window.android.carWashSearch();
    }
}

// 拉起原生系统消息页面
export const carWashMessage = () => {
    if (isiOS()) {
        window.webkit.messageHandlers.carWashMessage.postMessage({});
    } else {
        window.android.carWashMessage();
    }
}

// 扫描行驶证
export const getRecognizeVehicleLicense = () => {
    if (!isMiniProgram()) {
        if (isiOS()) {
            window.webkit.messageHandlers.goScanDrivingLicense.postMessage({});
        } else {
            window.android.goScanDrivingLicense();
        }
    }
}
// app跳转小程序的h5
export const toMiniProgramWeb = (url) => {
    if (isiOS()) {
        window.webkit.messageHandlers.toMiniProgramWeb.postMessage({ url });
    } else {
        window.android.toMiniProgramWeb(url);
    }
}
// app跳转小程序原生页面
export const toMiniProgramNativePage = (url) => {
    if (isiOS()) {
        window.webkit.messageHandlers.toMiniProgramNativePage.postMessage({ url });
    } else {
        window.android.toMiniProgramNativePage(url);
    }
}


// 商品专题页app跳转
export const goCommonPathAndReturnTootPage = (path, type) => {
    if (!isMiniProgram()) {
        if (isiOS()) {
            window.webkit.messageHandlers.goCommonPathAndReturnTootPage.postMessage({
                path: path.toString(), type: type
            });
        } else {
            window.android.goCommonPathAndReturnTootPage(path.toString(), parseInt(type));
        }
    }
}
